import PropTypes from 'prop-types';
import EBPropTypes from 'js-utils/prop-types';

import { gettext } from '@eb/i18n';

import { HEADER_IMAGES_PROPTYPES } from './header';
import { ONLINE_BANNER_URL } from './constants';

const CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES = {
    collectionLink:
        'https://www.eventbrite.com/c/the-best-online-events-to-attend-right-from-your-home-cwwqhpk/',
    collectionPrefix: 'cwwqhpk',
    shouldShowCustomHeader: true,
};

export const SEASONAL_CONTENT = {
    default: {
        coronavirus: {
            startDate: {
                day: 18,
                month: 3,
                year: 2020,
            },
            endDate: {
                day: 18,
                month: 3,
                year: 2220,
            },
            key: 'coronavirus',
            combinedHeaderTitleAndCta: gettext(
                '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
            ),
            linkLabel: gettext('Browse events'),
            headerImages: {
                mobile: ONLINE_BANNER_URL,
                tablet: ONLINE_BANNER_URL,
                desktop: ONLINE_BANNER_URL,
                twok: ONLINE_BANNER_URL,
            },
            collectionLink: '/d/online/events/',
            shouldShowCustomHeader: true,
            alwaysShow: true,
        },
        julyFourth: {
            key: 'julyFourth',
            tabName: 'July 4th',
            startDate: {
                day: 1,
                month: 5,
            },
            endDate: {
                day: 5,
                month: 6,
            },
            forceDisable: true,
            headerImages: {
                mobile: 'http://data.whicdn.com/images/124607322/large.png',
                tablet: 'http://data.whicdn.com/images/124607322/large.png',
                desktop: 'http://data.whicdn.com/images/124607322/large.png',
                twok: 'http://data.whicdn.com/images/124607322/large.png',
            },
            attribution: 'July 4th',
            cta: 'July 4th with your family',
            collectionLink: '',
            collectionPrefix: '',
        },
        halloween: {
            key: 'halloween',
            tabName: 'Halloween',
            startDate: {
                day: 1,
                month: 9,
            },
            endDate: {
                day: 1,
                month: 11,
            },
            forceDisable: false,
            headerImages: {
                mobile:
                    'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F72472033%2F232138391026%2F1%2Foriginal.20190911-181159?w=1024&auto=compress&s=5f4832f2a477b11f0c2726846a582bb8',
                tablet:
                    'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F72472033%2F232138391026%2F1%2Foriginal.20190911-181159?w=1024&auto=compress&s=5f4832f2a477b11f0c2726846a582bb8',
                desktop:
                    'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F72472033%2F232138391026%2F1%2Foriginal.20190911-181159?w=1024&auto=compress&s=5f4832f2a477b11f0c2726846a582bb8',
                twok:
                    'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F72472033%2F232138391026%2F1%2Foriginal.20190911-181159?w=1024&auto=compress&s=5f4832f2a477b11f0c2726846a582bb8',
            },
            attribution: 'Alyssa Bonanno',
            cta: 'Halloween',
            collectionLink:
                'https://www.eventbrite.com/c/the-best-halloween-parties-in-san-francisco-cgrkyyw/',
        },
        thanksgiving: {
            key: 'thanksgiving',
            tabName: 'Thanksgiving',
            startDate: {
                day: 12,
                month: 11,
            },
            endDate: {
                day: 27,
                month: 11,
            },
            forceDisable: false,
            headerImages: {
                mobile:
                    'https://cdn.evbstatic.com/s3-build/perm_001/8b6c4f/django/images/homefeed/seasonal/thanksgiving-480-mobile.jpg',
                tablet:
                    'https://cdn.evbstatic.com/s3-build/perm_001/decea1/django/images/homefeed/seasonal/thanksgiving-792-tablet.jpg',
                desktop:
                    'https://cdn.evbstatic.com/s3-build/perm_001/d517df/django/images/homefeed/seasonal/thanksgiving-1080-desktop.jpg',
                twok:
                    'https://cdn.evbstatic.com/s3-build/perm_001/3a6e23/django/images/homefeed/seasonal/thanksgiving-2600-large.jpg',
            },
            attribution: 'St. Anthonys / Serve Meals / San Francisco',
            headerTitle: 'Made for those who',
            cta: 'give back',
            collectionLink: '',
        },
        NYE: {
            key: 'NYE',
            tabName: gettext("New Year's eve"),
            eventSearchQ: gettext('new year'),
            startDate: {
                day: 28,
                month: 11,
                year: 2019,
            },
            endDate: {
                day: 3,
                month: 1,
                year: 2020,
            },
            forceDisable: false,
            headerImages: {
                mobile:
                    'https://cdn.evbstatic.com/s3-build/perm_001/6144f0/django/images/homefeed/seasonal/nye-480-mobile.jpg',
                tablet:
                    'https://cdn.evbstatic.com/s3-build/perm_001/4a7749/django/images/homefeed/seasonal/nye-792-tablet.jpg',
                desktop:
                    'https://cdn.evbstatic.com/s3-build/perm_001/588e89/django/images/homefeed/seasonal/nye-1080-desktop.jpg',
                twok:
                    'https://cdn.evbstatic.com/s3-build/perm_001/9a49da/django/images/homefeed/seasonal/nye-2600-large.jpg',
            },
            attribution: 'Lion Babe / Elsewhere / New York',
            headerTitle: 'Made for those who do',
            cta: "New Year's Eve",
            linkLabel: "See New Year's Eve events",
            collectionLink: '',
        },
        mothersDay: {
            key: 'mothersDay',
            tabName: gettext("Mother's day"),
            eventSearchQ: gettext("mother's day"),
            onlineOnly: true,
            startDate: {
                day: 8,
                month: 5,
            },
            endDate: {
                day: 11,
                month: 5,
            },
            combinedHeaderTitleAndCta: gettext(
                '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
            ),
            linkLabel: gettext('Browse events'),
            headerImages: {
                mobile: ONLINE_BANNER_URL,
                tablet: ONLINE_BANNER_URL,
                desktop: ONLINE_BANNER_URL,
                twok: ONLINE_BANNER_URL,
            },
            collectionLink: '/d/online/events/',
            shouldShowCustomHeader: true,
            alwaysShow: true,
        },
        pride: {
            key: 'pride',
            tabName: gettext('Pride'),
            eventSearchQ: gettext('pride'),
            onlineOnly: true,
            startDate: {
                day: 28,
                month: 5,
                year: 2020,
            },
            endDate: {
                day: 30,
                month: 6,
                year: 2020,
            },
            combinedHeaderTitleAndCta: gettext(
                '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
            ),
            linkLabel: gettext('Browse events'),
            headerImages: {
                mobile: ONLINE_BANNER_URL,
                tablet: ONLINE_BANNER_URL,
                desktop: ONLINE_BANNER_URL,
                twok: ONLINE_BANNER_URL,
            },
            collectionLink: '/d/online/events/',
            shouldShowCustomHeader: true,
            alwaysShow: true,
        },
    },
    // New York
    '85977539': {
        coronavirus: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        mothersDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        pride: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        julyFourth: {
            collectionLink: '',
            collectionPrefix: '',
        },
        halloween: {
            collectionLink:
                'https://www.eventbrite.com/c/halloween-parties-nyc-cgrkdxb/',
            collectionPrefix: 'cgrkdxb',
            shouldShowCustomHeader: false,
        },
        thanksgiving: {
            collectionLink:
                'https://www.eventbrite.com/c/volunteer-opportunities-new-york-city-cwtfwbg/',
            collectionPrefix: 'cwtfwbg',
            shouldShowCustomHeader: true,
        },
        NYE: {
            collectionLink:
                'https://www.eventbrite.com/c/made-for-those-who-do-new-years-eve-in-new-york-city-cwtgckw/',
            collectionPrefix: 'cwtgckw',
            shouldShowCustomHeader: true,
        },
    },
    // San Francisco
    '85922583': {
        coronavirus: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        mothersDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        pride: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        julyFourth: {
            collectionLink: '',
            collectionPrefix: '',
        },
        halloween: {
            collectionLink:
                'https://www.eventbrite.com/c/the-best-halloween-parties-in-san-francisco-cgrkyyw/',
            collectionPrefix: 'cgrkyyw',
            shouldShowCustomHeader: false,
        },
        thanksgiving: {
            collectionLink:
                'https://www.eventbrite.com/c/volunteer-opportunities-san-francisco-cwtdtpd/',
            collectionPrefix: 'cwtdtpd',
            shouldShowCustomHeader: true,
        },
        NYE: {
            collectionLink:
                'https://www.eventbrite.com/c/san-franciscos-best-new-years-eve-parties-and-shows-cwtgmcb/',
            collectionPrefix: 'cwtgmcb',
            shouldShowCustomHeader: true,
        },
    },
    // Los Angeles
    '85923517': {
        coronavirus: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        mothersDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        pride: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        julyFourth: {
            collectionLink: '',
            collectionPrefix: '',
        },
        halloween: {
            collectionLink:
                'https://www.eventbrite.com/c/the-best-halloween-parties-in-los-angeles-cgrkwgr/',
            collectionPrefix: 'cgrkwgr',
            shouldShowCustomHeader: false,
        },
        thanksgiving: {
            collectionLink:
                'https://www.eventbrite.com/c/volunteer-opportunities-los-angeles-cwtgchd/',
            collectionPrefix: 'cwtgchd',
            shouldShowCustomHeader: true,
        },
        NYE: {
            collectionLink:
                'https://www.eventbrite.com/c/los-angeless-best-new-years-eve-parties-and-shows-cwtgcpk/',
            collectionPrefix: 'cwtgcpk',
            shouldShowCustomHeader: true,
        },
    },
    // Washington DC
    '85931779': {
        coronavirus: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        mothersDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        pride: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        julyFourth: {
            collectionLink: '',
            collectionPrefix: '',
        },
        halloween: {
            collectionLink:
                'https://www.eventbrite.com/c/the-best-halloween-parties-in-washington-dc-cgrkwmk/',
            collectionPrefix: 'cgrkwmk',
            shouldShowCustomHeader: false,
        },
        thanksgiving: {
            collectionLink:
                'https://www.eventbrite.com/c/volunteer-opportunities-washington-dc-cwtgckk/',
            collectionPrefix: 'cwtgckk',
            shouldShowCustomHeader: true,
        },
        NYE: {
            collectionLink:
                'https://www.eventbrite.com/c/washington-dcs-best-new-years-eve-parties-and-shows-cwtgcrb/',
            collectionPrefix: 'cwtgcrb',
            shouldShowCustomHeader: true,
        },
    },
    // Chicago
    '85940195': {
        coronavirus: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        mothersDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        pride: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        julyFourth: {
            collectionLink: '',
            collectionPrefix: '',
        },
        halloween: {
            collectionLink:
                'https://www.eventbrite.com/c/the-best-halloween-parties-in-chicago-cgrkwrr/',
            collectionPrefix: 'cgrkwrr',
            shouldShowCustomHeader: false,
        },
        thanksgiving: {
            collectionLink:
                'https://www.eventbrite.com/c/volunteering-opportunities-chicago-cwtgckd/',
            collectionPrefix: 'cwtgckd',
            shouldShowCustomHeader: true,
        },
        NYE: {
            collectionLink:
                'https://www.eventbrite.com/c/chicagos-best-new-years-eve-parties-and-shows-cwtgcwp/',
            collectionPrefix: 'cwtgcwp',
            shouldShowCustomHeader: true,
        },
    },
    // Philadelphia
    '101718083': {
        coronavirus: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        mothersDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        pride: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        julyFourth: {
            collectionLink: '',
            collectionPrefix: '',
        },
        halloween: {
            collectionLink:
                'https://www.eventbrite.com/c/best-halloween-parties-philadelphia-chkwzwk/',
            collectionPrefix: 'chkwzwk',
            shouldShowCustomHeader: false,
        },
        thanksgiving: {
            collectionLink: '',
            collectionPrefix: '',
        },
        NYE: {
            collectionLink: '',
            collectionPrefix: '',
            shouldShowCustomHeader: false,
        },
    },
    // Atlanta
    '85936429': {
        coronavirus: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        mothersDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        pride: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        NYE: {
            collectionLink:
                'https://www.eventbrite.com/c/atlantas-best-new-years-eve-parties-and-shows-cwtgcxk/',
            collectionPrefix: 'cwtgcxk',
            shouldShowCustomHeader: true,
        },
    },
};

export const BASE_SEASONAL_CONTENT_PROPTYPES = {
    byDate: PropTypes.shape({
        key: PropTypes.string,
        startDate: PropTypes.shape({
            day: PropTypes.number,
            month: PropTypes.number,
        }),
        endDate: PropTypes.shape({
            day: PropTypes.number,
            month: PropTypes.number,
        }),
        eventSearchQ: EBPropTypes.translation,
        onlineOnly: PropTypes.bool,
        forceDisable: PropTypes.bool,
        headerImages: PropTypes.shape(HEADER_IMAGES_PROPTYPES),
        attribution: PropTypes.string,
        cta: PropTypes.string,
        linkLabel: EBPropTypes.translation,
    }),
    byPlace: PropTypes.shape({
        collectionLink: PropTypes.string,
        collectionPrefix: PropTypes.string,
        shouldShowCustomHeader: PropTypes.bool,
    }),
};
